import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SB303Service } from "app/services/303/303.service";
import { SharedService } from "app/services/core/shared.service";
import { ToastrService } from "ngx-toastr";

@Component({
    selector: 'app-sb303-notes',
    templateUrl: './dialog-sb303-notes.component.html',
    standalone: false
})

export class DialogSB303NotesComponent {
  public entityId = "";
  public entityType = "";
  public editingNotes = false;

  constructor(
    public dialogRef: MatDialogRef<DialogSB303NotesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public sb303Service: SB303Service,
    public sharedService: SharedService,
    public toastr: ToastrService) {
      this.entityId = this.data.entityId;
      this.entityType = this.data.entityType;
      this.editingNotes = this.data.editingNotes;
    }
}
